import React, { FC, memo } from "react";

const MailboxHeader: FC = () => {
  return null;
};

export default memo(MailboxHeader);
